module.exports = __webpack_public_path__ + "media/images/result_sets/circles/1n2r7r4n-dc33f744e2ca6a03a4cb400a3852d52d.svg";